import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Column, Checkbox } from '@pella/sash-framework';

const PccCard = ({ data, tallyQuoteRequest, disabled = false }) => {
	const [checked, setChecked] = useState(false);

	const onCheckboxToggle = (e) => {
		const action = e.target.checked ? 'add' : 'subtract';
		const selectedPCC = data;

		tallyQuoteRequest(action, selectedPCC);
		setChecked(!checked);
	};

	return (
		<div
			className='border-b border-b-gray-15 p-5 md:p-7 [&:nth-child(odd)]:bg-gray-3'
			data-testid='pcc-card'
		>
			<Row verticalGutters>
				<Column
					lg='auto'
					className='hidden lg:block'
				>
					{data.level === 'Platinum Elite' ? (
						<img
							src='https://images.contentstack.io/v3/assets/bltf589e66bcaecd79c/bltb9f157ddd951cbb2/pcc-elite.svg'
							alt={data.level}
						/>
					) : data.level === 'Platinum' ? (
						<img
							src='https://images.contentstack.io/v3/assets/bltf589e66bcaecd79c/bltda06f5ceab386185/pcc-platinum.svg'
							alt={data.level}
						/>
					) : data.level === 'Standard' ? (
						<img
							src='https://images.contentstack.io/v3/assets/bltf589e66bcaecd79c/bltfa060c9160f3d9dc/pcc-logo.svg'
							alt={data.level}
						/>
					) : (
						<img
							src='https://images.contentstack.io/v3/assets/bltf589e66bcaecd79c/blt52f2586488cbec33/pcc-premier.svg'
							alt={data.level}
						/>
					)}
				</Column>

				<Column
					xs={12}
					lg='fluid'
				>
					{data.name && <h3 className='mb-1'>{data.name}</h3>}

					<p className='mt-1 text-gray-70'>
						{data.line_1 != null && <span>{data.line_1}</span>}
						{data.line_2 != null && <span>{', ' + data.line_2}</span>} {data.city != null && <span>{data.city}</span>}, {data.state != null && <span>{data.state}</span>} {data.postal_code != null && <span>{data.postal_code}</span>}
					</p>

					{data.phone != null && <p className='mt-1 text-gray-70'>{data.phone}</p>}

					{data.bio && <p className='mt-7 hidden lg:block'>{data.bio}</p>}

					{data.specialties && (
						<Row className='hidden lg:mt-5 lg:flex'>
							<Column xs={12}>
								<strong>Specialties:</strong>
							</Column>
							{data.specialties.split(',').map((specialty, index) => (
								<Column
									xs={12}
									md={4}
									key={index}
								>
									<p className='mt-2.5'>{specialty}</p>
								</Column>
							))}
						</Row>
					)}
				</Column>

				<Column
					xs={12}
					lg='auto'
					className={!checked && disabled ? 'opacity-50' : ''}
				>
					<Checkbox
						type='checkbox'
						id={data._id}
						labelText='Get a Quote'
						disabled={!checked && disabled ? true : false}
						onChange={onCheckboxToggle}
						groupClass='[&_label]:mb-0'
					/>
				</Column>
			</Row>
		</div>
	);
};

PccCard.propTypes = {
	data: PropTypes.object,
	tallyQuoteRequest: PropTypes.func,
	disabled: PropTypes.bool,
};

export default PccCard;
